import React, { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import seoServices from "../images/seo-services.avif";
import { Helmet } from "react-helmet-async";

export default function SEOservices() {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  const primaryColor = "#684df4";

  const seoProcess = [
    { icon: "fa-search", title: "Website Deep Analysis", desc: "Comprehensive audit of your site’s technical health, speed, mobile-friendliness, structure, and current SEO performance to uncover quick wins and long-term opportunities." },
    { icon: "fa-chart-bar", title: "Competitor & Market Research", desc: "In-depth analysis of top-ranking competitors — their keywords, backlinks, content strategy, and UX — to build a smarter, more aggressive plan." },
    { icon: "fa-key", title: "Keyword Research & Strategy", desc: "Identify high-intent, low-competition keywords + trending search terms, then create a prioritized mix that drives real traffic and conversions." },
    { icon: "fa-file-alt", title: "On-Page Optimization & Content Restructuring", desc: "Optimize titles, meta, headings, internal links, schema, and rewrite/refresh content to make every page search-engine loved and user-friendly." },
    { icon: "fa-link", title: "Strategic Link Building", desc: "Earn high-authority, relevant backlinks through outreach, guest posts, partnerships, and digital PR — boosting domain strength safely and sustainably." },
    { icon: "fa-chart-line", title: "Continuous Monitoring & Refinement", desc: "Track rankings, traffic, conversions & behavior with tools like Google Analytics & Search Console — then iterate monthly for steady, long-term growth." },
  ];

  return (
    <div>
      <Helmet>
        <title>Professional SEO Services in Pakistan - Technic Mentors</title>
        <link rel="canonical" href="https://technicmentors.com/seo-services/" />
      </Helmet>

      {/* Hero Header */}
      <div className="allHeaderBg">
        <div className="allHeader-overlay d-flex align-items-center justify-content-center">
          <div>
            <h1 className="head text-center text-white animate__animated animate__zoomIn allHeaderP">
              Best SEO Services in Pakistan
            </h1>
          </div>
        </div>
      </div>

      {/* Introduction */}
      <div className="container mt-5" data-aos="fade-up" data-aos-duration="1000">
        <div className="row align-items-center g-5">
          <div className="col-lg-6" data-aos="fade-right" data-aos-duration="1200">
            <div className="section-title text-start mb-4">
              <h2>The Visible, The Successful</h2>
              <h3 style={{ fontSize: "2.4rem", fontWeight: 700 }}>
                Dominate Search with Our <span>Proven SEO Services</span>
              </h3>
            </div>
            <p style={{ textAlign: "justify", lineHeight: 1.8, fontSize: "1.05rem" }}>
              In today’s digital-first world, appearing on page 1 of Google isn’t optional — it’s how customers find you. We help businesses in Pakistan (and beyond) rank higher, attract high-intent traffic, and convert visitors into loyal customers through ethical, results-driven SEO.
            </p>
            <p style={{ textAlign: "justify", lineHeight: 1.8 }}>
              From technical audits and keyword domination to content strategy, link building, and performance tracking — we deliver transparent, sustainable growth that lasts.
            </p>
          </div>

          <div className="col-lg-6" data-aos="fade-left" data-aos-duration="1200">
            <img
              src={seoServices}
              alt="SEO Services in Pakistan"
              className="img-fluid "
              style={{ borderRadius: "16px" }}
            />
          </div>
        </div>
      </div>

      {/* How We Do It - SEO Process Cards */}
      <div className="container my-2 py-2" data-aos="fade-up" data-aos-duration="1000">
        <div className="section-title text-center mb-2">
          <h3>Our Proven SEO Process</h3>
        </div>
        <div className="row g-4">
          {seoProcess.map((item, i) => (
            <div className="col-lg-4 col-md-6" key={i}>
              <div
                className="card shadow-sm h-100 text-center p-4"
                style={{
                  transition: 'all 0.28s ease',
                  borderRadius: '16px',
                  border: '1px solid #e0e0e0',
                  backgroundColor: '#ffffff',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = primaryColor;
                  e.currentTarget.style.color = '#ffffff';
                  e.currentTarget.style.transform = 'translateY(-12px) scale(1.04)';
                  e.currentTarget.style.boxShadow = '0 25px 60px rgba(0,0,0,0.18)';
                  e.currentTarget.style.borderColor = primaryColor;
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = '#ffffff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'white';
                  e.currentTarget.style.color = 'inherit';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
                  e.currentTarget.style.borderColor = '#e0e0e0';
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = primaryColor;
                }}
              >
                <i
                  className={`fa-solid ${item.icon} fa-4x mb-4`}
                  style={{ color: primaryColor, transition: 'color 0.28s ease' }}
                ></i>
                <h5 className="mb-3 fw-bold">{item.title}</h5>
                <p className="mb-0 small" style={{ lineHeight: 1.6 }}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Why Choose Us / Closing */}
      <div
        className="container-fluid py-2"
        style={{
          background: `linear-gradient(135deg, ${primaryColor}08 0%, #f8f9fa 100%)`,
        }}
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h3 className="mb-4" style={{ fontWeight: 700 }}>
                Why Businesses in Pakistan Trust Our SEO Services
              </h3>
              <p className="lead mb-4" style={{ lineHeight: 1.8 }}>
                We don’t just chase rankings — we build sustainable visibility, targeted traffic, and real business growth. With deep keyword research, clean technical SEO, high-quality content, ethical link building, and monthly transparent reporting — we help Gujranwala, Lahore, Karachi, and international clients dominate Google.
              </p>
              <p style={{ fontSize: "1.1rem", maxWidth: "900px", margin: "0 auto 2rem" }}>
                Whether you're a local business, e-commerce store, educational platform, or service provider — our data-driven, white-hat SEO strategies deliver long-term results you can measure and trust.
              </p>

             <a
  href="/contact"
  className="primaryBtn px-4 py-2 mb-3"
  style={{ display: "inline-block" }}
>
  Contact Us &rarr;
</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}